export const imageExtensions: string[] = [
	"bmp",
	"jpeg",
	"jpg",
	"png",
	"svg"
]

